// extracted by mini-css-extract-plugin
export default {"storyCountainer":"Storycontent_storyCountainer__sJtKm","storyimg":"Storycontent_storyimg__SLnvD","storytext":"Storycontent_storytext__gUEf0"};